import { useI18n } from '../common/i18n/I18n';
import { TYPE_TO_ICON } from '../common/icons/typeToIcon';

export const formatItemForPerson = (item) => ({
    id: item.id,
    name: item.name,
    role: item.role,
    label: item.name,
    subLabel: item.contactInfo?.email?.address,
    ref: { ...item.reference, label: item.name },
    contactInfo: item.contactInfo,
    professionalRoles: item.professionalRoles
});

export const formatItemForOrg = (item) => ({
    id: item.id,
    name: item.name,
    label: item.name,
    isSharedInDirectory: item.isSharedInDirectory,
    subLabel: item.contact?.contactInfo?.email?.address,
    contactInfo: item.contact?.contactInfo,
    ref: { ...item.reference, label: item.name },
    professionalRoles: item.professionalRoles
});

export const formatShortlistItem = (item) => ({
    ...item,
    name:
        typeof item.name === 'object' && item.name?.firstName && item.name?.lastName
            ? `${item.name?.firstName} ${item.name?.lastName}`.trim()
            : item.name || item.publicName,
    headline: item.headline || item.summary?.headline || '',
    about: item.about || item.summary?.about || '',
    organization: item.experiences?.[0]?.organizationReference?.label || item.organization || '',
    location: item.location?.label || item.location || item.locations?.[0]?.label || ''
});

export const handleItemSelection = (item, setSelectedItem, setDetailsVisible) => {
    const updatedItem = formatShortlistItem(item);
    setSelectedItem(updatedItem);
    setDetailsVisible(true);
};

export const useShowNames = () => {
    const hireCrew = useI18n('resource.hire.type.crew');
    const hireSupplier = useI18n('resource.hire.type.supplier');
    return [hireCrew, hireSupplier];
};

export const getResourceTypes = () => {
    // The sequence of array should match with show names sequence to get the right icons
    return ['Crew', 'Supplier'];
};

export const getIconForShowNames = (index: number, resourceTypes: string[]) => {
    const type = resourceTypes[index];
    const Icon = TYPE_TO_ICON[type] || TYPE_TO_ICON['Default'];
    return Icon;
};
